import React from "react";
import {injectIntl} from "react-intl";

export default (WrappedComponent) => {

    class WrappedIntlComponent extends React.Component {

        formatMessage = (id) => {
            return this.props.intl.formatMessage({id});
        };

        render() {
            window.___formageMessage = this.formatMessage // TODO dev only
            return <WrappedComponent formatMessage={this.formatMessage} {...this.props} />;

        }

    }

    return injectIntl(WrappedIntlComponent);

}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/intl/WrappedIntlComponent.js